import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import type { Employee } from '../../types/employee';

interface EmployeeContextMenuProps {
  anchorEl: HTMLElement | null;
  selectedEmployee: Employee | null;
  onClose: () => void;
  onEdit: (employee: Employee) => void;
  onIncreaseRate: (employee: Employee) => void;
  onHistory: (employee: Employee) => void;
  onRetire: (employee: Employee) => void;
  onRestore: (employee: Employee) => void;
  onDelete: (employee: Employee) => void;
}

export const EmployeeContextMenu: React.FC<EmployeeContextMenuProps> = ({
  anchorEl,
  selectedEmployee,
  onClose,
  onEdit,
  onIncreaseRate,
  onHistory,
  onRetire,
  onRestore,
  onDelete,
}) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
    {selectedEmployee && !selectedEmployee.isRetired && (
      <MenuItem onClick={() => { onEdit(selectedEmployee); onClose(); }}>
        수정
      </MenuItem>
    )}
    {selectedEmployee && !selectedEmployee.isRetired && selectedEmployee.isHourly && (
      <MenuItem onClick={() => { onIncreaseRate(selectedEmployee); onClose(); }}>
        시급 올리기
      </MenuItem>
    )}
    {selectedEmployee && !selectedEmployee.isRetired && selectedEmployee.isHourly && (
      <MenuItem onClick={() => { onHistory(selectedEmployee); onClose(); }}>
        시급 변경 이력
      </MenuItem>
    )}
    {selectedEmployee && !selectedEmployee.isRetired && (
      <MenuItem onClick={() => onRetire(selectedEmployee)}>
        퇴직 처리
      </MenuItem>
    )}
    {selectedEmployee && selectedEmployee.isRetired && (
      <MenuItem onClick={() => onRestore(selectedEmployee)}>
        복원
      </MenuItem>
    )}
    {selectedEmployee && selectedEmployee.isRetired && (
      <MenuItem onClick={() => onDelete(selectedEmployee)} sx={{ color: 'error.main' }}>
        삭제
      </MenuItem>
    )}
  </Menu>
);
